export const CALCULATOR_DATA = {
  data: {
    25: {'men': 100, 'women': 100},
    26: {'men': 98, 'women': 98},
    27: {'men': 97, 'women': 97},
    28: {'men': 95, 'women': 95},
    29: {'men': 94, 'women': 94},
    30: {'men': 92, 'women': 92},
    31: {'men': 91, 'women': 91},
    32: {'men': 89, 'women': 89},
    33: {'men': 88, 'women': 88},
    34: {'men': 86, 'women': 86},
    35: {'men': 85, 'women': 85},
    36: {'men': 83, 'women': 83},
    37: {'men': 82, 'women': 82},
    38: {'men': 81, 'women': 81},
    39: {'men': 79, 'women': 79},
    40: {'men': 78, 'women': 78},
    41: {'men': 77, 'women': 77},
    42: {'men': 75, 'women': 75},
    43: {'men': 74, 'women': 74},
    44: {'men': 73, 'women': 73},
    45: {'men': 72, 'women': 72},
    46: {'men': 71, 'women': 71},
    47: {'men': 69, 'women': 69},
    48: {'men': 68, 'women': 68},
    49: {'men': 67, 'women': 67},
    50: {'men': 66, 'women': 66},
    51: {'men': 65, 'women': 62},
    52: {'men': 64, 'women': 57},
    53: {'men': 63, 'women': 53},
    54: {'men': 62, 'women': 48},
    55: {'men': 61, 'women': 44},
    56: {'men': 60, 'women': 43},
    57: {'men': 59, 'women': 42},
    58: {'men': 58, 'women': 41},
    59: {'men': 57, 'women': 40},
    60: {'men': 56, 'women': 40},
    61: {'men': 55, 'women': 39},
    62: {'men': 54, 'women': 38},
    63: {'men': 53, 'women': 37},
    64: {'men': 52, 'women': 36},
    65: {'men': 51, 'women': 36},
    66: {'men': 51, 'women': 35},
    67: {'men': 50, 'women': 34},
    68: {'men': 49, 'women': 33},
    69: {'men': 48, 'women': 33},
    70: {'men': 47, 'women': 32},
    71: {'men': 47, 'women': 31},
    72: {'men': 46, 'women': 31},
    73: {'men': 45, 'women': 30},
    74: {'men': 44, 'women': 30},
    75: {'men': 44, 'women': 29},
    76: {'men': 43, 'women': 29},
    77: {'men': 42, 'women': 28},
    78: {'men': 41, 'women': 28},
    79: {'men': 41, 'women': 28},
    80: {'men': 40, 'women': 27},
    81: {'men': 39, 'women': 27},
    82: {'men': 39, 'women': 26},
    83: {'men': 38, 'women': 26},
    84: {'men': 37, 'women': 25},
    85: {'men': 37, 'women': 25},
    86: {'men': 36, 'women': 25},
    87: {'men': 36, 'women': 24},
    88: {'men': 35, 'women': 24},
    89: {'men': 34, 'women': 23},
    90: {'men': 34, 'women': 23},
    91: {'men': 33, 'women': 23},
    92: {'men': 33, 'women': 22},
    93: {'men': 32, 'women': 22},
    94: {'men': 32, 'women': 21},
    95: {'men': 31, 'women': 21},
    96: {'men': 31, 'women': 21},
    97: {'men': 30, 'women': 20},
    98: {'men': 30, 'women': 20},
    99: {'men': 29, 'women': 20},
    100: {'men': 29, 'women': 19},
    101: {'men': 28, 'women': 19},
    102: {'men': 28, 'women': 19},
    103: {'men': 27, 'women': 18},
    104: {'men': 27, 'women': 18},
    105: {'men': 26, 'women': 18},
    106: {'men': 26, 'women': 18},
    107: {'men': 26, 'women': 17},
    108: {'men': 25, 'women': 17},
    109: {'men': 25, 'women': 17},
    110: {'men': 24, 'women': 16},
    111: {'men': 24, 'women': 16},
    112: {'men': 24, 'women': 16},
    113: {'men': 23, 'women': 16},
    114: {'men': 23, 'women': 15},
    115: {'men': 22, 'women': 15},
    116: {'men': 22, 'women': 15},
    117: {'men': 22, 'women': 15},
    118: {'men': 21, 'women': 14},
    119: {'men': 21, 'women': 14},
    120: {'men': 21, 'women': 14}
  },
  icons: {
    men: 'illustrationBodyMan',
    women: 'illustrationBodyWoman'
  },
  texts: {
    step2: {
      infoMsg: '<p>Podając adres e-mail, wyrażasz zgodę na otrzymywanie naszego newslettera. Zasady świadczenia usługi newsletter opisuje <a href="/pl/regulamin" target="_blank" rel="noopener">Regulamin</a>. Klauzulę informacyjną zawiera <a target="_blank" rel="noopener" href="/pl/polityka-prywatnosci">Polityka&nbsp;Prywatności</a>',
    }
  }
};
